var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.66675V3.33341H16.6722C17.1293 3.33341 17.5 3.70421 17.5 4.16125V17.5056C17.5 17.9627 17.1292 18.3334 16.6722 18.3334H3.32783C2.87063 18.3334 2.5 17.9627 2.5 17.5056V4.16125C2.5 3.70405 2.87079 3.33341 3.32783 3.33341H5.83333V1.66675H14.1667ZM5.83333 5.00008H4.16667V16.6667H15.8333V5.00008H14.1667V6.66675H5.83333V5.00008ZM9.16667 13.3334V15.0001H5.83333V13.3334H9.16667ZM14.1667 10.8334V12.5001H5.83333V10.8334H14.1667ZM10.8333 8.33341V10.0001H5.83333V8.33341H10.8333ZM12.5 3.33341H7.5V5.00008H12.5V3.33341Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Report.d8b39fc2.svg";
export { ForwardRef as ReactComponent };